/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type KiteHomeTotalTrxCountInfo = {
    TRXTP: KiteHomeTotalTrxCountInfo.TRXTP;
    TTRXCNT: string;
};

export namespace KiteHomeTotalTrxCountInfo {

    export enum TRXTP {
        NORMAL = 'NORMAL',
        INTERNAL = 'INTERNAL',
        PENDING = 'PENDING',
    }


}

